import {
  Button,
  CardActions,
  CardContent,
  CardMedia,
  Card,
  Avatar,
} from "@mui/material";
import moment from "moment";

import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import Constants from "../data/Constants";

function CartItem(props) {
  const { item, onClick, className } = props;

  const course = item.course;

  return item && course ? (
    <Card sx={{ width: "300px" }} className={className} onClick={onClick}>
      <CardMedia
        component="img"
        className="object-cover"
        style={{ height: "150px" }}
        image={course.cover.url}
      />
      <CardContent>
        <div className="text-lg font-bold text-ellipsis truncate">
          {course.name}
        </div>
        <div className="flex text-sm my-2">
          <div className="">{course.type}</div>
          {course.type != "Subscription" && (
            <div className="ml-auto">
              {Constants.CURRENCY_SYMBOL + course.salePrice}
              <strike> {Constants.CURRENCY_SYMBOL + course.costPrice}</strike>
            </div>
          )}
        </div>
        <div className="text-ellipsis truncate text-gray-600 text-sm">
          {course.shortDescription}
        </div>

        <div className="flex gap-3 items-center bg-gray-100 p-2 my-2 rounded-md">
          <Avatar />

          <div className="flex flex-col">
            <div className="font-bold">
              {item.boughtFor.firstname + " " + item.boughtFor.lastname}
            </div>
            <div className="text-sm">Grade {item.boughtFor.grade}</div>
          </div>
        </div>

        {item.courseClass && (
          <div className="flex text-sm py-2 items-center bg-secondary  p-2 my-2 rounded-md">
            <b>BATCH {item.courseClass.batchNumber}</b>
            <div className="ml-auto">
              {item.courseClass.sessions.length} sessions
            </div>
          </div>
        )}

        {item.subscriptionPlan && (
          <div className="flex text-sm bg-blue-100 rounded-md items-center p-2 my-2">
            <h1 className="font-bold">{item.subscriptionPlan.friendlyTime}</h1>
            <div className="ml-auto">
              {Constants.CURRENCY_SYMBOL + course.salePrice}
              <strike> {Constants.CURRENCY_SYMBOL + course.costPrice}</strike>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  ) : (
    <Card sx={{ width: "300px" }} className={className} onClick={onClick}>
      <div className="flex items-center justify-center m-2">
        <Avatar src={item.mentor.picture} sx={{ width: 100, height: 100 }} />
      </div>
      <CardContent>
        <h1 className="text-center font-bold text-md">
          {item.mentor.firstname + " " + item.mentor.lastname}
        </h1>

        <div className="flex text-sm my-2">
          <div className="">Counselling</div>
          <div className="ml-auto">
            {Constants.CURRENCY_SYMBOL + item.salePrice}
            <strike> {Constants.CURRENCY_SYMBOL + item.costPrice}</strike>
          </div>
        </div>

        <div className="flex gap-3 items-center bg-gray-100 p-2 my-2 rounded-md">
          <Avatar />

          <div className="flex flex-col">
            <div className="font-bold">
              {item.boughtFor.firstname + " " + item.boughtFor.lastname}
            </div>
            <div className="text-sm">Grade {item.boughtFor.grade}</div>
          </div>
        </div>

        {
          <div className="text-sm py-2  bg-secondary  p-2 my-2 rounded-md">
            <div className="flex flex-grow gap-2 w-100">
              <b>SLOT</b>
              <div>{item.slot.duration} mins</div>
            </div>
            <div>
              {moment(item.slot.time).format("h:mm a") +
                " - " +
                moment(item.slot.time)
                  .add(item.slot.duration, "minutes")
                  .format("h:mm a") +
                " on " +
                moment(item.slot.time).format("DD/MM/YYYY")}
            </div>
          </div>
        }
      </CardContent>
    </Card>
  );
}

export default CartItem;
